import { useMemo } from 'react';
import type { UserSubstitutionItem } from 'types';

interface UseSubstitutionActiveStatusParams {
  substitutionData?: UserSubstitutionItem | null;
}

export const useSubstitutionActiveStatus = ({ substitutionData }: UseSubstitutionActiveStatusParams): boolean => {
  return useMemo(() => {
    if (!substitutionData) {
      return false;
    }

    const now = new Date();

    if (!substitutionData.validTo) {
      return new Date(substitutionData.validFrom) <= now;
    }

    return new Date(substitutionData.validTo) >= now && new Date(substitutionData.validFrom) <= now;
  }, [substitutionData]);
};
